import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { ResponseUnidadEducativaProyectoModel, UnidadEducativaProyectoModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { ProyectoEducativoContextoDataModel, ProyectoEducativoDataModel, ResponseProyectoEducativoContextoDataModel, ResponseProyectoEducativoDataModel } from 'src/app/model/ProyectoEducativoData.model';
import { apiService } from 'src/app/service/api.service';
import { ProyectoEducativoComponent } from '../../proyecto-educativo.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-proyecto-educativo-contexto',
  templateUrl: './proyecto-educativo-contexto.component.html',
  styleUrls: ['./proyecto-educativo-contexto.component.css']
})
export class ProyectoEducativoContextoComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  @Input() simulacion: boolean;
  cargando : boolean;
  dataJardin = new JardinModel();
  proyectoEducativoContextoDataModel = new ProyectoEducativoContextoDataModel();
  public isCollapsed1 = true;
  public isCollapsed2 = true;

  cambios: boolean;
  guardarEditar : boolean;
  guardarEditarAux :string;
  constructor(
    @Inject(ProyectoEducativoComponent) private parent: ProyectoEducativoComponent,
    private api: apiService,
  ) { }

  ngOnInit(): void {
    this.cargaInicial();
    this.cambios = false;
  }


  cargaInicial(){
    this.dataJardin = this.api.dataJardin;
    this.proyectoEducativo(this.dataJardin);
    this.cargando = true;
  }


  proyectoEducativo(dataJardin:JardinModel){
    this.api.API_POST_obtenerProyectoEducativoContextoData(dataJardin.id).subscribe((response: ResponseProyectoEducativoContextoDataModel) => {
      this.proyectoEducativoContextoDataModel = response.payload;  
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
      this.guardarEditarAux = sessionStorage.getItem('guardarEditar');
      if(this.guardarEditarAux  === 'true'){
        this.guardarEditar=true;
      }else{
        this.guardarEditar=false;
      }
    },
    (err) => {
      this.divSpinner.nativeElement.style.display='none';
      this.cargando = false;
      console.log(err)
    });  
}

change() {
  this.cambios = true;
}


guardarContexto(){
  this.divSpinner.nativeElement.style.display='';
  this.api.API_POST_actualizarProyectoEducativoContextoData(this.proyectoEducativoContextoDataModel).subscribe((response: ResponseProyectoEducativoContextoDataModel) => {
    this.proyectoEducativoContextoDataModel = response.payload;  
    this.divSpinner.nativeElement.style.display='none';
    this.cambios = false;
  },
  (err) => {
    this.divSpinner.nativeElement.style.display='none';
    console.log(err)
  });  
  
}

  volver(){
    if (this.cambios == true){
      Swal.fire({
        title: 'Tiene cambios sin guardar, ¿desea continuar?',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.parent.ngOnInit();
        } 
      })
    }else {
      this.parent.ngOnInit();
    } 
  }
    volver2(){

      this.parent.ngOnInit();
    
  }
}
